import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { MAX_PREPAY_VALUE_TO_LABEL } from './constants';
import { EMaxPrepay } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'maxPrepay' as const;

export const maxPrepayTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const maxPrepay = getTermValue('prepay')(jsonQuery);

    if (maxPrepay === null || maxPrepay === EMaxPrepay.Any) {
      return null;
    }

    const label = `Предоплата: ${MAX_PREPAY_VALUE_TO_LABEL[maxPrepay]}`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['prepay'])(jsonQuery),
};
